import BaseLayer from "./BaseLayer";
import {drawLine} from "../utils/map_utils";

class TXTYText extends BaseLayer {
    id = "txtyText";
    label = "TXTY Text";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {scanMeta, textColor, textSize} = this.props;
        for (let key in scanMeta) {
            if (key.endsWith("_5"))
                continue;

            let {y_fields, tile_width, tile_height, uperpixel, img_type} = this.props.slide;
            
            let x = scanMeta[key]["col"];
            let y = scanMeta[key]["row"];
            y = y_fields - y - 1;
            
            if (scanMeta[key]["top"] !== undefined) 
                drawLine((x + 0.5) * (tile_width * uperpixel), (y + 1) * (tile_height * uperpixel), 1,
                    this.layer.getSource(), scanMeta[key]["top"]["ty"] + "_" + scanMeta[key]["top"]["tx"],
                    1, "#00ffea", "", textColor, textSize);
            if (scanMeta[key]["left"] !== undefined)
                drawLine(x * (tile_width * uperpixel), (y + 0.5) * (tile_height * uperpixel), 1,
                    this.layer.getSource(), scanMeta[key]["left"]["tx"] + "_" + scanMeta[key]["left"]["ty"],
                    1, "#00ffea", "", textColor, textSize);
        }
        resolve();
    });
}

export default TXTYText;
